export const NAME = 'contactsTake';

export const allowedSearchCombination = [
	['policyNumber'],
	['personIn'],
	['surname', 'firstName', 'municipality'],
	['surname', 'firstName', 'zipCode'],
];

export const dialogError = `${NAME}/requiredFields`;
